declare var window: any;

// Converted as hook from apps/admin_web/assets/node_modules/flowbite/src/components/dismiss.js
const Dismiss = {
  mounted(this: any) {
    const triggerEl = this.el;
    const targetEl = document.querySelector(
      triggerEl.getAttribute("data-dismiss-target"),
    );
    new window.Dismiss(targetEl, { triggerEl });
  },
};

export default Dismiss;
